import { render } from "./CashReceived.vue?vue&type=template&id=71d0c22b"
import script from "./CashReceived.vue?vue&type=script&lang=js"
export * from "./CashReceived.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__